import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Button } from '@/components/Button';

type Step = { id: string; label: string };

type Props = {
  steps: Step[];
  activeIndex: number;
  onBack: () => void;
  onNext: () => void;
  canGoBack: boolean;
  canGoNext: boolean;
  nextLabel?: string;
  children: React.ReactNode;
  sidePanel?: React.ReactNode;
};

export function WizardShell({
  steps,
  activeIndex,
  onBack,
  onNext,
  canGoBack,
  canGoNext,
  nextLabel = 'Continue',
  children,
  sidePanel,
}: Props) {
  return (
    <div className='mx-auto flex max-w-6xl flex-col gap-8 px-4 py-8 lg:flex-row lg:py-12'>
      <div className='flex-1 min-w-0'>
        <ol className='mb-8 flex flex-wrap gap-2' aria-label='Steps'>
          {steps.map((s, i) => (
            <li
              key={s.id}
              className={`rounded-full px-3 py-1 text-xs font-medium ${
                i === activeIndex
                  ? 'bg-primary text-white'
                  : i < activeIndex
                    ? 'bg-primary/15 text-primary'
                    : 'bg-gray-100 text-gray-500'
              }`}
            >
              {i + 1}. {s.label}
            </li>
          ))}
        </ol>
        {children}
        <div className='mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-gray-200 pt-6'>
          <Button
            type='button'
            variant='secondary'
            onClick={onBack}
            disabled={!canGoBack}
            className='inline-flex items-center gap-1'
          >
            <FiChevronLeft /> Back
          </Button>
          <Button
            type='button'
            onClick={onNext}
            disabled={!canGoNext}
            className='inline-flex items-center gap-1'
          >
            {nextLabel} <FiChevronRight />
          </Button>
        </div>
      </div>
      {sidePanel ? (
        <aside className='w-full shrink-0 lg:w-80 xl:w-96' aria-label='Plan preview'>
          {sidePanel}
        </aside>
      ) : null}
    </div>
  );
}
